import { defineBreakpoints, defineComponents, defineDesignTokens } from '@contentful/experiences-sdk-react';
import { lazy } from 'react';
import { buttonComponentDefinition } from './studio/button-def';
import { BlockSideBySideComponentDefinition } from './studio/block-side-by-side-def';
const HeroDisplay = lazy(() => import('@fm-nx/ui').then((mod) => ({ default: mod.HeroDisplay })));
const ButtonDisplay = lazy(() => import('@fm-nx/ui').then((mod) => ({ default: mod.ButtonDisplay })));
const PageSectionDisplay = lazy(() => import('@fm-nx/ui').then((mod) => ({ default: mod.PageSectionDisplay })));

//Configure your components, design tokens, and custom breakpoints here

defineComponents([
    {
        component: ButtonDisplay,
        definition: buttonComponentDefinition,
    },
    {
        component: PageSectionDisplay,
        definition: BlockSideBySideComponentDefinition,
    },
    {
        component: HeroDisplay,
        definition: {
            id: 'hero',
            name: 'Hero',
            category: 'Custom Components',
            children: true,
            slots: {
                buttonsSlot: {
                    displayName: 'Buttons',
                },
            },
            variables: {
                overline: {
                    displayName: 'Overline',
                    type: 'Text',
                    defaultValue: 'Overline',
                    group: 'content',
                },
                backgroundImage: {
                    displayName: 'Background Image',
                    type: 'Link',
                    group: 'content',
                },
                backgroundImageOpacity: {
                    displayName: 'Background Image Opacity',
                    type: 'Number',
                    group: 'style',
                },
            },
        },
    },
]);

defineBreakpoints([
    // Add your custom breakpoints here
    // example:
    // {
    //   id: 'test-desktop',
    //   query: '*',
    //   displayName: 'All Sizes',
    //   displayIcon: 'desktop',
    //   previewSize: '100%',
    // },
    // {
    //   id: 'test-tablet',
    //   query: '<982px',
    //   displayName: 'Tablet',
    //   displayIcon: 'tablet',
    //   previewSize: '820px',
    // },
    // {
    //   id: 'test-mobile',
    //   query: '<576px',
    //   displayName: 'Mobile',
    //   displayIcon: 'mobile',
    //   previewSize: '390px',
    // },
]);

defineDesignTokens({
    // Add your design tokens here
    // example:
    // spacing: { XS: '4px', S: '16px', M: '32px', L: '64px', XL: '128px' },
    // sizing: { XS: '16px', S: '100px', M: '300px', L: '600px', XL: '1024px' },
    color: {
        Chartreuse: '#cccc33',
        Azure: 'azure',
        Orange: '#fdba74',
        Blue: '#0000ff',
    },
    textColor: {
        Dark: '#1a1a1a',
        Chartreuse: '#cccc33',
        Light: '#efefef',
    },
    fontFamily: {
        headline:
            'Formular, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji',
        text: 'Sailec, ui-serif, Georgia, Cambria, Times New Roman, Times, serif',
        mono: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    },
});
